function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import Input from './input';
import classnames from 'classnames';

/**
 *
 * A wrapper around the {@link Input} component that adds an icon to the input.
 *
 * This icon is rendered as an `<i>` tag, with a dynamic class based on the `icon` prop.
 * For example, given an `icon` prop of `"twitter"`, the component will render an {@link Input} with child `<i className="twitter-icon"/>`.
 *
 * Additionally, the fieldset of this {@link Input} will be given the class `"icon-label"` for styling purposes.
 *
 * @name IconInput
 * @type Function
 * @param {String} icon - The name of the icon associated with the input
 * @example
 *
 * function TwitterForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field
 *          name="handle"
 *          component={ IconInput }
 *          icon="twitter"
 *          placeholder="Your twitter handle"
 *       />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 */

var propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired
};
function IconInput(props) {
  var icon = props.icon,
    className = props.className;
  return /*#__PURE__*/React.createElement(Input, _objectSpread(_objectSpread({}, props), {}, {
    className: classnames('icon-label', className)
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(icon, "-icon")
  }));
}
IconInput.propTypes = propTypes;
export default IconInput;